import './App.css';
import { Suspense, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Footer from './components/Footer';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import NotFound404 from './components/NotFound';
import PageTransition from './components/PageTransition';
import Realizacje from './pages/Realizacje';
import RealizacjeDetails from './pages/RealizacjeDetails';
import Omnie from './pages/Omnie';
import Oferta from './pages/Oferta';
import Kontakt from './pages/Kontakt';

function App() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="App">
      <Navigation />

      <Suspense fallback={<div>Ładowanie strony...</div>}>
        <Routes location={location} key={location.pathname}>
          <Route
            path="/"
            element={
              <PageTransition>
                <Home />
              </PageTransition>
            }
          />
          <Route
            path="/realizacje"
            element={
              <PageTransition>
                <Realizacje />
              </PageTransition>
            }
          />
          <Route
            path="/realizacje/:id"
            element={
              <PageTransition>
                <RealizacjeDetails />
              </PageTransition>
            }
          />
          <Route
            path="/about"
            element={
              <PageTransition>
                <Omnie />
              </PageTransition>
            }
          />
          <Route
            path="/oferta"
            element={
              <PageTransition>
                <Oferta />
              </PageTransition>
            }
          />
          <Route path="*" element={<NotFound404 />} />
           <Route
            path="/kontakt"
            element={
              <PageTransition>
                <Kontakt />
              </PageTransition>
            }
          />
          <Route path="*" element={<NotFound404 />} />
        </Routes>
      </Suspense>

      <Footer />
    </div>
  );
}

export default App;

